// src/components/warnings/WarningList.jsx
// The warnings of one run: landing duplicates merged, red first, one banner each.
// `warnings` is null when the run has none (never []).
import React from 'react';
import WarningBanner from './WarningBanner.jsx';
import { consolidateLandingWarnings, sortBySeverity } from './warningCopy.js';

export default function WarningList({ warnings, t }) {
  if (!Array.isArray(warnings) || warnings.length === 0) return null;
  const shown = sortBySeverity(consolidateLandingWarnings(warnings));
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      {shown.map((warning, i) => (
        <WarningBanner key={`${warning.code || warning.agent || 'w'}-${i}`} warning={warning} t={t} />
      ))}
    </div>
  );
}
